//import { toast } from "react-hot-toast";
import Swal from "sweetalert2";

export const handleApiSuccess = (response, fallbackMessage = "عملیات با موفقیت انجام شد") => {
  let message = fallbackMessage;

  if (response.data) {
    const data = response.data;

    if (typeof data.message === "string") {
      message = data.message;
    } else if (Array.isArray(data.message)) {
      message = data.message.join("\n");
    } else if (typeof data === "string") {
      message = data;
    }
  }

  Swal.fire({
    icon: 'success', title: 'موفقیت', timer: 2000, showConfirmButton: false,
    text: message,
  });
}

export const handleApiError = (err, fallbackMessage = "خطایی رخ داد") => {
  console.error(err);

  let message = fallbackMessage;

  // بررسی پاسخ سرور
  if (err.response && err.response.data) {
    const data = err.response.data;

    if (typeof data.message === "string") {
      message = data.message;
    } else if (Array.isArray(data.message)) {
      message = data.message.join("\n");
    } else if (typeof data === "string") {
      message = data;
    }
  }

  //toast.error(message);
};
